const fieldLabels = {
  nome: 'Nome',
  telefone: 'Telefone',
  email: 'E-mail',
  empresa: 'Empresa',
  cidade: 'Cidade',
  estado: 'Estado',
};

const humanize = value => String(value || '')
  .replaceAll('_', ' ')
  .replace(/^./, letter => letter.toUpperCase());

export const formatExtraValue = value => {
  if (Array.isArray(value)) return value.filter(Boolean).join(', ');
  if (value && typeof value === 'object') return JSON.stringify(value, null, 2);
  return String(value ?? '');
};

export const commercialQualificationDetails = (qualification, lead = {}) => {
  if (!qualification || typeof qualification !== 'object' || Array.isArray(qualification)) {
    return [];
  }

  const details = [];
  if (qualification.interest) {
    details.push({ label: 'Interesse comercial', value: qualification.interest });
  }

  Object.entries(qualification.qualification_answers || {}).forEach(([question, answer]) => {
    if (answer !== null && answer !== '') {
      details.push({ label: question, value: formatExtraValue(answer) });
    }
  });

  Object.entries(qualification.collected_fields || {}).forEach(([field, value]) => {
    const duplicatesLeadField = String(lead[field] ?? '').trim().toLocaleLowerCase()
      === String(value ?? '').trim().toLocaleLowerCase();
    if (value !== null && value !== '' && !duplicatesLeadField) {
      details.push({
        label: fieldLabels[field] || humanize(field),
        value: formatExtraValue(value),
      });
    }
  });

  return details;
};
